import { qformat, timeZoneAbbr } from 'views_shared/app/javascript/utils/dateFormatters';
import { profileUrl } from 'views_shared/app/javascript/utils/urls';
import { entitySubtitle } from 'views_shared/app/javascript/utils/entityDisplay';

// Full-body plain text with line breaks preserved (stripHtmlTags is preview-only: first line + …)
export function htmlToMultilineText(html) {
  if (!html) return '';
  return html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(?:p|div|h[1-6]|li|blockquote)>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

const formatTimestamp = (seconds) => {
  const total = Math.floor(seconds);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
};

// The download-selected-text payload, shaped after V1's show.text.erb / _pitch.text.erb
export default function buildPitchesText(request, pitches, conversationsByPitchId, transcriptsByPitchId = {}) {
  const { origin } = window.location;

  // V1-MIGRATION: the reporter downloads from the request page itself — use its URL
  const header = `${request.title}\n${origin}${window.location.pathname}\n`;

  const blocks = pitches.map((pitch) => {
    const lines = [];
    const who = [
      pitch.profile_name,
      pitch.profile_title_at_workplace,
      `(${origin}${profileUrl({ slug: pitch.profile_slug, user_migrate_id: pitch.user_migrate_id })})`,
    ]
      .filter(Boolean)
      .join(', ');
    lines.push(`PR: ${who}`, '');

    const entities = pitch.pitched_entities || [];
    if (entities.length > 0) {
      lines.push('Proposed Sources:');
      entities.forEach((entity) => {
        const title = entitySubtitle(entity);
        lines.push(`  * ${[entity.name, title].filter(Boolean).join(', ')}, ${origin}/sources/${entity.slug}`);
      });
      lines.push('');
    }

    const edited = pitch.after_send_edited_at ? ' (Edited Since)' : '';
    lines.push(`${qformat(pitch.sent_at, 'MMM d, yyyy, h:mm a', '')} ${timeZoneAbbr(pitch.sent_at)}${edited}`, '');

    lines.push(htmlToMultilineText(pitch.pitch_text), '');

    const hasVideo = (pitch.pitch_attachments || []).some((a) => a.type === 'Interact::Attachment::Video');
    if (hasVideo) {
      const segments = transcriptsByPitchId[pitch.id];
      if (segments?.length) {
        lines.push('Video Pitch Transcript:');
        segments.forEach((segment) => lines.push(`  [${formatTimestamp(segment.start)}] ${segment.text}`));
      } else {
        lines.push('Video Pitch: attached (no transcript available)');
      }
      lines.push('');
    }

    const conversation = conversationsByPitchId[pitch.id];
    if (conversation?.num_messages > 0) {
      lines.push(
        `${conversation.num_messages} Messages Exchanged: ${origin}/my_inbox_v2?conversation=${conversation.conversation_id}`,
        '',
      );
    }

    return lines.join('\n');
  });

  return `${header}\n${blocks.join(`\n${'\n'.repeat(4)}`)}\n`;
}
